import whyUsContent from "./content/why-us.json";

export const whyUsMock = {
  name: "why-us",
  layoutType: 1,
  areasList: [
    {
      id: "why-us-1",
      name: "why-us-content",
      componentName: "Comp:WhyUsPage",
      content: JSON.stringify(whyUsContent),
    },
  ],
};
